import React from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Header, Modal, Loader, Dimmer } from 'semantic-ui-react';
import { hideAddCommentModal, showCountDetailsModal, showCollectionBreakdownModal, showAddCommentModal, showSiteVarianceHistoryModal, hideCollectionBreakdownModal, showSuccessAlert } from '../../redux/actions/modals';
import PrimaryTabs from '../CollectionBreakdown/PrimaryTabs';
import SecondaryTabs from '../CollectionBreakdown/SecondaryTabs';
import collections from '../../api/collections';
import count from '../../api/count';

class CollectionBreakdownModal extends React.Component {

  state = {
    loading: false,
    detailsRow: null,
  }

  componentDidUpdate(prevProps) {
    if (this.props.modal.collectionId && this.props.modal.collectionId !== prevProps.modal.collectionId) {
      this.getComments();
    }
  }
  
  getComments = () => {
    const { collectionId } = this.props.modal;
      collections.getCommentsByCollection(collectionId).then(
        response => {
          this.props.showCollectionBreakdownModal({...this.props.modal, comments: response.comments }, this.props.modal.onRefresh, this.props.modal.onClose)
        },
        () => this.setState({ loading: false })
      );
  }

  handleVarianceHistory = () => this.props.showSiteVarianceHistoryModal(true);

  onRowClick = (row) => this.props.showMachineCollectionDetailsModal(true);

  handleClose = () => {
    this.setState({ loading: true }, () => {
      this.props.modal.onClose().then(() => {
        setTimeout(() => this.setState({ loading: false }, () => this.props.hideCollectionBreakdownModal()), 500);
      })
    })
  }

  handleViewComments = () => this.props.showBankingCommentsModal(true)

  handleCommentSave = async (comment) => {
    const { collectionId } = this.props.modal;
    collections.addComment(collectionId, comment).then(
      result => this.props.showSuccessAlert(result, "Success", async () => {
        this.props.hideAddCommentModal();
        this.getComments();
      })
    );
  }

  handleAddComment = () => {
    const { siteText, weekText, egmText } = this.props.modal;
    this.props.showAddCommentModal(`${siteText} - ${weekText}`, egmText, this.handleCommentSave, this.getComments)
  }
  
  onDetailsRowClick = detailsRow => this.setState({ detailsRow })
  
  onCountDetailsClick = async () => {
    const { batchId, collectionType } = this.state.detailsRow;
    this.props.showCountDetailsModal({batchId, collectionType }, this.handleCommentSave);
  }

  render() {
    const { detailsRow } = this.state;
    const { optionShowExport, optionShowVarianceHistory } = this.props.modal;
    return (
      <Modal
          open={this.props.modal.open}
          onClose={this.handleClose}
          size='fullscreen'
          closeIcon
          className="h-80"
      >
        <Modal.Header>Collection Breakdown</Modal.Header>
        <Modal.Content className="h-100">
          <Dimmer active={this.state.loading} inverted>
            <Loader inverted content='Loading' />
          </Dimmer>
          <Grid className="height-100 flex-container">
            <Grid.Row>
              <Grid.Column width="8">
                <Header size="small" className="mb-1">
                  {this.props.modal.siteText} - {this.props.modal.weekText} 
                  <Header.Subheader>{this.props.modal.egmText}</Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width="8" textAlign="right">
                <Button color="blue" content="Count Details" disabled={!detailsRow} onClick={this.onCountDetailsClick} />
                <Button color="teal" onClick={this.handleAddComment}>Add Comment</Button>
                { optionShowVarianceHistory && <Button positive>Site Variance History</Button> }
                { optionShowExport && <Button color="blue">Export</Button> }
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column width="10" className="height-100 gs-flex-container-vertical">
                <PrimaryTabs onDetailsRowClick={this.onDetailsRowClick} />
              </Grid.Column>
              <Grid.Column width="6" className="height-100 gs-flex-container-vertical">
                <SecondaryTabs />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, { showSuccessAlert, showCountDetailsModal, showSiteVarianceHistoryModal, showAddCommentModal, showCollectionBreakdownModal, hideAddCommentModal, hideCollectionBreakdownModal })(CollectionBreakdownModal);
